import { render, staticRenderFns } from "./UID.vue?vue&type=template&id=9acae976&"
import script from "./UID.vue?vue&type=script&lang=js&"
export * from "./UID.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports